import 'ol/ol.css';
import '../css/fonts.css';
import '../css/header.css';
import './css/services.css';
import './css/preview.css';

import Map from 'ol/Map';
import View from 'ol/View';
import WMS from 'ol/source/ImageWMS';
import {createFromCapabilitiesMatrixSet} from 'ol/tilegrid/WMTS';
import {get as getProjection, transformExtent} from 'ol/proj';
import { containsExtent } from 'ol/extent';
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';

import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';

import tracker from '../js/n4m5/util/tracker.js';
import matomo from '../matomo.js';

proj4.defs("EPSG:3035","+proj=laea +axis=neu +lon_0=10 +lat_0=52 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");
proj4.defs("EPSG:3031","+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs");
proj4.defs("EPSG:3996","+proj=stere +lat_0=90 +lat_ts=75 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs");

const extent = {
    'EPSG:3035': [-605551.336, -1208408.744, 7972573.664, 7369716.256],
    'EPSG:3031': [-3333070.789, -3346177.41, 3345987.697, 3332881.076],
	'EPSG:3996': [-3368012.081, -3375204.22, 3375268.122, 3368075.983]	
}

register(proj4);

const coastlines = new ImageLayer({
	source: new WMS({
		url: 'https://ows.emodnet-bathymetry.eu/wms',
		wrapX: true,
		
		params: {
			LAYERS: 'coastlines',
		}		
	}),
	visible: false
});


const tileLayer = new TileLayer({
	opacity: 1
});

let view = new View({
	projection: 'EPSG:4326',
	center: [5, 47],
	zoom: 5
})

const map = new Map({
  layers: [	tileLayer, coastlines ],
  target: 'map',
  view: view 
});

document.getElementById('coastline').addEventListener('change', event => {
	coastlines.setVisible(event.target.checked);
})

const optionLayer = document.getElementById('layer');
const optionTileset = document.getElementById('tileset');

const parser = new WMTSCapabilities();

const layers = {};
const tileMatrix = {};

let previousTileset;

const updateSelectedLayer = (identifier) => {
	const data = layers[ identifier ];

	optionTileset.innerHTML = '';

	data.forEach(({identifier}) => {
		const option = document.createElement("option");
		option.value = identifier;
		option.text = identifier;
		
		
		optionTileset.add(option);		
	});	

	const selectedIndex = data.findIndex(value => value.identifier === previousTileset);
	if( selectedIndex >= 0) {
		optionTileset.selectedIndex = selectedIndex
	}
	
	updateSelectTileSet( optionTileset.value);	
}

const updateSelectTileSet = (identifier) => {
	const tileset = layers[optionLayer.value].find( value => value.identifier === identifier);	
	const layer = tileset.source;
	const previousView = view;
	
	if( identifier !== previousTileset ) {
		view = null;
	}
	
	if( !view ) {
		const projection = layer.getProjection();		
		let extentLayer = layer.getTileGrid().getExtent();
		
		view = new View({
			projection: layer.getProjection(),
			zoom: 0,
			maxResolution: 1000000
		});	
		
	
		map.setView(view);			
		
		if( previousView ) {
			extentLayer = transformExtent(previousView.calculateExtent(), previousView.getProjection(), view.getProjection())
		}
		
		let maxExtent = layer.getTileGrid().getExtent();
		
		if(  extent.hasOwnProperty(projection.getCode()) ) {
			maxExtent = extent[projection.getCode()];			
		}	
		
		
		if( !containsExtent(maxExtent, extentLayer) ) {
			extentLayer = maxExtent;
		}

		view.fit(extentLayer);			
		previousTileset = identifier;
	}
	
	layer.setProperties({
		wrapX: true
	});
	
	tileLayer.setSource(layer);
};


optionLayer.addEventListener('change', event => updateSelectedLayer(event.target.value));
optionTileset.addEventListener('change', event => updateSelectTileSet(event.target.value));

const addTileSet = (value) => {
	const { Identifier, Title } = value;
	if( !tileMatrix.hasOwnProperty(Identifier) ) {
		tileMatrix[Identifier] = value;	
	}
}

const addLayer = ({Title, Identifier, TileMatrixSetLink, WGS84BoundingBox}, {TileMatrixSet}, capabilities) => {
	if( !layers.hasOwnProperty(Identifier) ) {
		layers[Identifier] = []
		
		const option = document.createElement("option");
		option.value = Identifier;
		option.text = Title;
		
		optionLayer.add(option);
	}	
		
	const options = optionsFromCapabilities(capabilities, {
		layer: Identifier,
		matrixSet: TileMatrixSet
	});
	
	options.wrapX = true;
	
	const source =  new WMTS(options);
	
	const projection = source.getProjection();
	let tileGrid = source.getTileGrid();
	let gridExtent = null; 
	
	if( extent.hasOwnProperty(projection.getCode()) ) {
		gridExtent = extent[projection.getCode()];		
	} else if( projection.getCode() === 'EPSG:4326') {
		gridExtent = WGS84BoundingBox;
	}
	
	if( gridExtent ) {
		const matrix = tileMatrix[TileMatrixSet];
		let limits = TileMatrixSetLink.filter(link => link.TileMatrixSet === TileMatrixSet);

		tileGrid = createFromCapabilitiesMatrixSet(matrix, gridExtent, limits[0].TileMatrixSetLimits);
		source.tileGrid = tileGrid;
	}
	
	layers[Identifier].push({
		identifier: TileMatrixSet,
		source: source
	});	
}

const initPreview = (url) => {
	fetch(url).then(response => response.text())
	.then(text => {
		const capabilities = parser.read(text);
		capabilities.Contents.TileMatrixSet.forEach(addTileSet);
		
		capabilities.Contents.Layer.sort((layer, other) => layer.Title.localeCompare(other.Title)).forEach(layer => {			
			layer.TileMatrixSetLink.forEach(link => addLayer(layer, link, capabilities))
		})
				
		updateSelectedLayer(optionLayer.value);
	});
};

initPreview(`https://tiles.emodnet-bathymetry.eu/wmts/1.0.0/WMTSCapabilities.xml?!?`);
//tracker(matomo.url, matomo.tracker_id);